<template>
  <div class="sucker-main" ref="activity_scroll" @scroll="activityScroll">
    <!-- 头部 -->
    <div class="pc-header" v-if="screenWidth > 992">
        <!-- <p class="pc-he-tip">eppendorf</p> -->
        <p class="pc-he-tip">
            <img src="https://static.eppendorf.com/assets/website/images/logoEppendorf.svg" alt="">
        </p>
        <p class="pc-he-sea">
            <input @keyup.enter="handeSeacher" type="text" v-model="seachName">
            <img class="pc-he-img" @click="handeSeacher" src="https://cdn.juplus.cn/FvysFANMfn56ivAGvIQvukEWVBjP" alt="">
        </p>
    </div>
    <!-- 筛选上 -->
    <div class="search-main">
        <div class="se-main-top">
            <img :src="'https://cdn.juplus.cn/' + pcOne.img_src" alt="">
            <!-- multiple -->
            <el-select v-if="screenWidth > 992" v-model="value1"  :placeholder="pcOne.title" placeholder-style="color:#fff" @change="handleTopOne($event,pcOne.id)" @remove-tag="handleRemove">
                <el-option
                v-for="item in optionsOne"
                :key="item.id"
                :label="item.title"
                :value="{value: item.value,toCid: item.to_cid}">
                </el-option>
            </el-select>
            <span @click="searchH5(h5One.id, 'blue')" class="h5-color" v-if="screenWidth < 992">{{h5One.title}} ></span>
        </div>
        <div  class="se-main-top">
            <img :src="'https://cdn.juplus.cn/' + pcTwo.img_src" alt="">
            <!-- multiple -->
            <el-select v-if="screenWidth > 992" v-model="value2" :placeholder="pcTwo.title" placeholder-style="color:#fff" @change="handleTopTwo($event,pcTwo.id)" @remove-tag="handleRemove">
                <el-option
                v-for="item in optionsTwo"
                :key="item.id"
                :label="item.title"
                :value="{value: item.value,toCid: item.cid_to}">
                </el-option>
            </el-select>
            <span @click="searchH5(h5Two.id, 'blue')" class="h5-color" v-if="screenWidth < 992">{{h5Two.title}} ></span>
        </div>
        <div v-if="screenWidth < 992" class="h5-search">
            <input @keyup.enter="handeSeacher" v-model="seachName" class="h5-se-input" type="text">
            <img @click="handeSeacher" width="22px" style="vertical-align: middle;" src="https://cdn.juplus.cn/FvysFANMfn56ivAGvIQvukEWVBjP" alt="">
        </div>
    </div>
    <!-- 筛选 --> 
    <div class="seach-main-two" v-show="isShowTwo">
        <ul class="seach-con" >
            <li v-for="(item,index) in suckList" :key="item.id">
                <div v-if="screenWidth > 992">
                    <img :src="'https://cdn.juplus.cn/' + item.img_src" alt="">
                    <span class="se-two-tip">{{ item.title }}</span>
                </div>
                <div class="se-two-input" v-if="screenWidth > 992">
                    <!-- multiple -->
                    <el-select multiple v-model="valueObj[index]"  value-key="value" placeholder="" @change="handleTopSuk($event,item.id)" @visible-change="handleTopSel" @remove-tag="handleRemove">
                        <el-option
                        v-for="ite in item.children"
                        :key="ite.id"
                        :label="ite.title"
                        :value="{ value: ite.value,title: ite.title,id: item.id}">
                        </el-option>
                    </el-select>
                </div>
                <div @click="searchH5(item.id)" class="se-two-h5" v-if="screenWidth < 992">
                    <!-- <span></span> -->
                    <img :src="'https://cdn.juplus.cn/' + item.img_src" alt="">
                    <span class="se-two-tip">{{ item.title }}</span>
                </div>
            </li>
        </ul>
    </div>
    <!-- tab -->
    <div class="tab-main">
        <van-tabs swipeable class="tab-tip" @click="onClickTab">
            <van-tab title="全部" >
            </van-tab>
            <van-tab v-for="item in packList" :title="item.title" :key="item.id" :name="item.id">
                <div class="tab-content">
                    <img :src="'https://cdn.juplus.cn/' + item.img_src" alt="">
                    <div v-html="item.desc">
                       
                    </div>
               </div>
            </van-tab>
        </van-tabs>
    </div>
    <!-- 产品 -->
    <ul class="product-main" >
        <li v-for="item in productList" :key="item.id">
            <div class="pic-text">
                <img v-if="screenWidth > 992" :src="'https://cdn.juplus.cn/' + item.cover_img" alt="">
                <div class="pic-text-div">
                    <p class="pic-tip-top alone-top font-14">{{ item.title }}</p>
                    <!-- <p class="pic-tip-cen font-12">{{ item.jianjie }}</p> -->
                    <div class="pic-tip-cen font-12" v-html="item.jianjie"></div>
                    <div class="pro-spec alone-pro-sp">
                        <div class="pro-sp-con pic-tip-ctn">
                            <p class="pic-tip-top font-14">吸头规格</p>
                            <p class="font-12">{{ item.spec }}</p>
                        </div>
                        <div v-if="screenWidth < 992" style="width:1px;background-color:#979797;">

                        </div>
                        <div class="pro-sp-con pro-sp-left">
                            <p class="pic-tip-top font-14">产品包装</p>
                            <p class="pic-tip-cen font-12">{{ item.ctn }}</p>
                        </div>
                        <div v-if="screenWidth < 992" style="width:1px;background-color:#979797;">

                        </div>
                        <div class=" pro-sp-left">
                            <p class="font-14">产品货号</p>
                            <p class="font-12 pic-tip-cen">{{ item.number }}</p>
                        </div>
                    </div>
                    <div class="pro-btn" v-if="screenWidth < 992" @click="purchase(item.buy_link,item.id)">
                        <span>立即购买</span>
                    </div>
                </div>
            </div>
            <div class="pro-btn" v-if="screenWidth > 992" @click="purchase(item.buy_link,item.id)">
                <span>立即购买</span>
            </div>
        </li>
    </ul>
    <div class="show-nopro" v-show="productList.length == 0">
        暂无该组合产品，请查看其他选项
    </div>
    <van-popup
      v-model="showBottomPosition"
      position="bottom"
      :style="{ height: '60%' }"
    >
        <p class="h5-pop-tip">{{ h5SearchList.title }}</p>
        <!-- v-if="currentId == '184' || currentId == '189'" -->
        <van-radio-group v-if="currentId == '184' || currentId == '189'" v-model="H5RadioDefalut" style="padding: 0 8px;padding-top: 53px;" @change="handleH5Se">
            <van-radio v-for="item in h5SearchList" :key="item.id" :name="item.id" @click="handleceshi(currentId,item.title)" checked-color="#5BC4DC">{{ item.title }}</van-radio>
        </van-radio-group>

        <van-checkbox-group v-if="currentId != '184' && currentId != '189'" v-model="newH5Data[type]" direction="horizontal" style="padding: 0 8px;padding-top: 53px;" ref="checkboxGroup" @change="handleH5Se">
            <van-checkbox v-for="item in h5SearchList" :key="item.id" :name="item.id" checked-color="#5BC4DC">{{ item.title }}</van-checkbox>
        </van-checkbox-group>
        <div class="h5-pop-btn">
            <span v-if="currentId != '184' && currentId != '189'" @click="toggleAll">重置</span>
            <span @click="determine">确定</span>
        </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getCategory } from '@/api/product'
import { setSeacher,getSukerList,setPurchaseNum } from '@/api/sucker'
import details from './mixins/details'
import store from '@/store'

export default {
    mixins: [details],
    computed: {
        ...mapState(["screenWidth"])
    },
    data () {
        return {
            pcOne: [],
            pcTwo: [],
            isShowTwo: false,
            seachName: '',
            searchValue: '',
            value1: [],
            value2: [],
            valueObj: {},
            showInput: false,
            options: [{
               
            }],
            optionsOne: [],// pc移液器的显示
            optionsTwo: [], // pc量程的显示
            optionsTwoDefalute: [], // 默认pc量程
            suckList: [],
            packList: [], // tabs
            newpackList: [], // 用于记录调整
            page: 1,
            productList: [],
            allSearch: [],
            allSearch2: [],
            categoryPara: {
                type:2, 
                type_id: '',
                uid: this.$store.state.user.id || 0,
                action: 1
            },
            currentId:'',
            last_page: '',
            pcData: {}, // 新的传输数据
            p_list:[],
            one_list: [],
            two_list: []
        }
    },
    mounted () {
        // this.$store.state.user.id
        
        store.commit("setScreenWidth", document.body.clientWidth);
        this.getallCategory()
        this.getProList()
        
    },
    methods: {
        // sharePage () {
        //   const params = {
        //       title: this.detailsObj.title, // 分享标题
        //       desc: this.shareDesc, // 分享描述
        //       link: `${window.location.href.split('#')[0]}#/productDetails?id=${this.id}&tabShow=${this.tabsActive}&showid=${this.showVideoId}`, // 分享链接
        //       imgUrl: `${this.cdnUrl}${this.detailsObj.cover_img}` // 分享图标
        //   }
        //   console.log('分享标题',this.detailsObj.title,'分享描述',this.shareDesc,'分享链接',params.link);
        //   // console.log('图片',`${this.cdnUrl}${this.detailsObj.cover_img}`);
        //   wxShare(params)
        // },
        onClickTab (name,title) {
            console.log('tab',name,title);
            let aa = this.packList.filter(ele => {
                if (ele.id != name) {
                    return ele.id
                }
            })
            if (title == '全部') {
                this.pcData['包装'] = []
                this.newH5Data['包装'] = []
            } else {
                this.pcData['包装'] = [name + '']
                this.newH5Data['包装'] = [name + '']
            }
            
            // console.log('tab===',this.allSearch);
            // let cc = this.allSearch.filter(ele => {
            //     let bb = aa.every(res => {
            //         if (ele != parseInt(res.id)) {
            //             return ele
            //         }
            //     })
            //     return bb
            // })
            // console.log('查看cc',cc);
            // if (cc.length > 0) {
            //     this.allSearch = cc
            // } else {
            //     if (name == 0) {
            //         this.allSearch = []
            //     } else {
            //         this.allSearch = [name]
            //     }
                
            // }
            
            // console.log('tab===ccccc',this.allSearch);
            this.page = 1
            if (this.screenWidth > 992) {
                this.getProList(this.pcData)
            } else {
                this.getProList(this.newH5Data)
            }
            
            // this.allSearch.push(params[params.length-1].value)
        },
        // 立即购买
        purchase (url,pid) {
            let para = {
                type:1, 
                type_id: pid,
                uid: this.$store.state.user.id || 0,
                action: 1
            }
            this.setPurFrequency(para,url)
            
        },
        // 记录立即购买/类别选择--人数次数
        setPurFrequency (para,url) {
            setPurchaseNum(para).then(res => {
                if (url) {
                    window.location.href = url
                }
                
            })
        },
        // 产品数据
        getProList (cid) {
            let para = {
                page: this.page,
                size: 10,
                type: 2,
                cid: cid,
                search: this.seachName
            }
            if (cid) {
                let cc = Object.keys(cid)
                
                if (cc.indexOf('184') != -1 && cc.indexOf('189') != -1 ) {
                    // console.log('都选中国');
                    // this.value1 = []
                    // this.value2 = []
                    // this.optionsTwo = this.optionsTwoDefalute
                    this.optionsOne = this.optionsOneDefalute
                    this.goto = false
                    // this.newH5Data = {}
                }
            }
            getSukerList(para).then(res => {
                if (this.page == 1) {
                    this.productList = res.data.data
                } else {
                    this.productList.push(...res.data.data)
                }
                
                this.last_page = res.data.last_page
                // console.log('产品数据',this.productList);
            })
        },
        activityScroll () {
            // console.log('查看');
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 5 // 距离底部距离
            this.scrollTop = scrollTop
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.page < this.last_page) {
                    this.page++
                    if (this.screenWidth > 992) {
                        this.getProList(this.pcData)
                    } else {
                        this.getProList(this.newH5Data)
                    }
                    
                }
            }
        },
        handeSeacher () { 
            this.searchRecord()
        },
        searchRecord () { // 搜索记录
            let para = {
                uid: this.$store.state.user.id || 0,
                title: this.seachName
            }
            setSeacher(para).then(res => {
                this.page = 1
                this.getProList()
            })
        },
        searchValueChange () {

        },
        handleTopSel () {
            if (this.value1.length == 0 || this.value2.length == 0) {
                this.$toast('请先选择蓝色区域的筛选')
                this.valueObj = {}
                return false
            }
            let obj = {
                '184': [],
                '173': ['151']
            }
            for (let key in obj) {
                if (obj[key].length == 0) {
                    delete obj[key]
                }
            }
            // console.log(obj);
        },
        handleTopSuk (params,type) {
            console.log('选择的最后',params);
            // params = [params]
            var arr=[]
            params.forEach((item,index)=>{
                arr.push(item.value)
            })
            this.handAllSea(arr,type)
            if(params.length>this.p_list.length){
                this.categoryPara.type_id = params[params.length-1].value
                this.setPurFrequency(this.categoryPara)
            }
            this.p_list=JSON.parse(JSON.stringify(params))
            this.currentId=params.length > 0? params[0].id:this.currentId
            if (this.value1.length == 0 || this.value2.length == 0) {
                return false
            }
            // let arr = []
            // console.log('选择的',params);
            // console.log('选择的id--',this.currentId);
            // if (params.length > 0) {
            //     console.log('选择的最后',params[params.length-1].value);
            //     // this.arr.push(params[params.length-1].value)

            //     this.handAllSea(params,type)

            //     this.categoryPara.type_id = params[params.length-1].value
            //     this.setPurFrequency(this.categoryPara)
            // }
            

            if (params.length > 0 && this.currentId == '173') {

                const { value, label } = params[0]
                this.setPack(params)
            } 
            if (params.length == 0 && this.currentId == '173') {
                this.setPack('1')
            }
            
            
        },
        handleRemove (val) {
            // console.log('移除',val);
            // console.log('移除',this.packList.length);
            // this.allSearch = this.allSearch.filter(ele => {
            //     if(ele !== val.value) {
            //         return ele
            //     }
            // })
            // if (this.packList.length < 1) {
            //     this.packList = JSON.parse(JSON.stringify(this.newpackList))
            // }
            // this.page = 1
            // this.getProList()
        },
        setPack (params) {
            if (params == '1') {
                this.packList = JSON.parse(JSON.stringify(this.newpackList))
                return false
            }
            
             let newLsit = JSON.parse(JSON.stringify(this.newpackList))
                let aac = newLsit.filter(ele => {
                    // console.log('外层的',ele);
                    let aa = params.filter(element => {
                        if (ele.value == element.value) {
                            // console.log('里层的===',ele);
                            return ele
                        }
                    });
                    // console.log('看看=====',aa);
                    if (aa.length > 0) {
                        return aa
                    }
                    
                })
                this.packList = JSON.parse(JSON.stringify(aac))
        },
        handleTopOne (val,type) {
            // console.log('移液器111',val);
            
            if (Object.keys(this.pcData).indexOf('184') != -1) {
                this.value2 = []
                this.pcData = {}
                this.valueObj = {}
            }
            this.handleRange(val.toCid)
            val = [val]
            var arr=[]
            val.forEach((item,index)=>{
                arr.push(item.value)
            })
            this.handAllSea(arr,type)
            if (val.length > this.one_list.length) {
                this.categoryPara.type_id = val[val.length-1].value
                this.setPurFrequency(this.categoryPara)
            }
            this.one_list=JSON.parse(JSON.stringify(val))
            this.oneSearch = val
           
            
            if (this.value1.length != 0 && this.value2.length != 0) {
                this.isShowTwo = true
            } else {
                this.isShowTwo = false
            }
        },
        handleRange (oneOp) {
            let vv = this.optionsTwoDefalute
            this.optionsTwo = this.optionsTwoDefalute
            vv = this.optionsTwo.filter(ele => {
                let aa = oneOp.filter(val => {
                    if (+ele.id == val) {
                        return ele
                    }
                    
                })
                if (aa.length > 0) {
                    return aa
                }
            })
            this.optionsTwo = vv
            // console.log('看看1111111',vv);
        },
        handleTopTwo (val,type) {
            // console.log('量成',val);
            this.handleTwoRange(val.toCid)
            val = [val]
            var arr=[]
            val.forEach((item,index)=>{
                arr.push(item.value)
            })
            this.handAllSea(arr,type)
            if (val.length > this.two_list.length) {
                this.categoryPara.type_id = val[val.length-1].value
                this.setPurFrequency(this.categoryPara)
            }
            this.two_list=JSON.parse(JSON.stringify(val))
            // console.log('量成',this.pcData)
            
            if (this.value1.length != 0 && this.value2.length != 0) {
                this.isShowTwo = true
            } else {
                this.isShowTwo = false
            }
            // console.log('看看2222',this.optionsTwo);
        },
        handleTwoRange (oneOp) {
            let vv = this.optionsOneDefalute
            this.optionsOne = this.optionsOneDefalute
            vv = this.optionsOne.filter(ele => {
                let aa = oneOp.filter(val => {
                    if (+ele.id == val) {
                        return ele
                    }
                    
                })
                if (aa.length > 0) {
                    return aa
                }
            })
            this.optionsOne = vv
            // console.log('看看',vv);
        },
        handAllSea (val,type) {
            // this.allSearch = Array.from(new Set(this.allSearch));
            this.pcData[type] = val
            // console.log('新的查看呢',this.pcData);
            console.log('提交的',this.pcData);
            for (let key in this.pcData) {
                this.pcData[key]
            }
            this.page = 1
            this.getProList(this.pcData)
        },
        showH5Input () {
            this.showInput = !this.showInput
        },
        getallCategory () { // 分类
            getCategory({type: 2}).then(res => {
                // console.log('数据',res);
                this.h5List = res
                this.pcOne = res[0]
                this.pcTwo = res[1]
                this.h5One = res[0]
                this.h5Two = res[1]
                this.optionsOne = res[0].children
                this.optionsTwo = res[1].children
                this.optionsTwoDefalute = res[1].children
                this.optionsOneDefalute = res[0].children
                this.suckList = res.slice(2)
                let pack = res.filter(ele => {
                    if (ele.id == '173') {
                        return ele.children
                    }
                })
                this.packList = pack[0].children
                this.newpackList = pack[0].children
                // console.log('第一个',this.packList);
            })
        }
    },
    beforeCreate() {
        document && document.querySelector('body').setAttribute('style', 'max-width: 1200px')
    },
    beforeDestroy() {
        // @ts-ignore
        document && document.querySelector('body').removeAttribute('style')
    }
}
</script>

<style lang="scss" scoped>
    @import 'index.scss';
    
</style>